import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';

export default function ActiveUsersTrendCo(props: any) {
  const { style, className, type, config, children, data: propsData, ...resetProps } = props || {};
  const { api, isSingle = true,refreshKey='', interval, dataKey = "keyMetricsData", extraParams, formatData} = config || {};


  const { gameCode } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
    };
  }, shallowEqual);

  const data = useMemo(() => {
    return {
      gameCode,
      ...(propsData || {})
      
    };
  }, [gameCode, propsData]);

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        refreshKey={refreshKey}
        formatData={formatData}
        interval={interval}
        dataKey={dataKey}
        beforeRequest={(data) => {
          const { filterVal, gameCode } = data;
          const { timeType, diff, rangeTime, ...filters } = filterVal || {};
          const params: any = {
            game_code: gameCode,
            start_time: rangeTime?.[0] || '',
            end_time: rangeTime?.[1] || '',
            period: PERIODTIMEOBJ[timeType] || 'daily',
            filters: formatFilterValues(filters),
            ...extraParams
          };
          if (!isSingle) {
            params.has_system_active_user_pie = true;
          }
          return params;
        }}
        trackData={['gameCode', "extraParams"]}>
        {React.Children.map(children, (child: any) => {
          return React.cloneElement(
            child,
            {
              ...resetProps,
              isSingle,
              state: {}
            }
          );
        })}
      </Service>
    </div>
  );
};
